<article class="content-block-logos section-outset-y">
  <div class="container">
    <header class="content-block-logos__header text-center mx-auto mb-4 text-max-width">
      <h1 class="h2 pb-2 text-primary">{{ block?.title }}</h1>
      <p class="type-body-sm text-muted" [innerHTML]="block?.text"></p>
      <div class="mt-1" *ngIf="block?.button?.routerLink || block?.button?.url">
        <a class="button button-link button--primary button--xs" [routerLink]="block.button.routerLink" *ngIf="block.button.routerLink">
          <span>{{ block?.button?.text || ('lees-meer' | fromDictionary) }}</span>
          <app-icon class="icon-chevron-right" anchor="icon-chevron-right"></app-icon>
        </a>
        <a class="button button-link button--primary button--xs" [href]="block.button.url" *ngIf="!block.button.routerLink">
          <span>{{ block?.button?.text || ('lees-meer' | fromDictionary) }}</span>
          <app-icon class="icon-chevron-right" anchor="icon-chevron-right"></app-icon>
        </a>
      </div>
    </header>

    <ul class="content-block-logos__gallery">
      <li *ngFor="let item of block?.logos">
        <figure>
          <a [href]="item.websiteUrl" *ngIf="item.websiteUrl" target="_blank">
            <img [src]="item.logoUrl" [alt]="item.title" />
          </a>
          <img [src]="item.logoUrl" *ngIf="!item.websiteUrl" [alt]="item.title" />
        </figure>
      </li>
    </ul>
  </div>
</article>
